import { inject } from "inversify";
import { Contexts, CurrentCaseService, getContainer, LoggerInterface, NamedBindings, TranslationService } from "@dandelion/core";
import { UserService } from "../services/UserService";
import { jwtDecode } from "jwt-decode";

export class UserIdleTimeManager {
  protected token = window.localStorage.getItem('jwtToken');
  protected logoutTimer: number | undefined;
  protected blurTimer: number | undefined;
  protected warningTimer: number | undefined;

  constructor(@inject(NamedBindings.UserService) private userService: UserService,
    @inject(NamedBindings.TranslationService) private ts: TranslationService,
    @inject(NamedBindings.Logger) private logger: LoggerInterface) {
    this.logoutTimer = undefined;
    this.blurTimer = undefined;
    this.warningTimer = undefined;
    window.addEventListener("load", (_event) => {
      this.resetTimer()
    });
    window.addEventListener("scroll", (_event) => {
      this.resetTimer()
    });
    window.addEventListener("mousemove", (_event) => {
      this.resetTimer()
    });
    window.addEventListener("keydown", (_event) => {
      this.resetTimer()
    });
  }

  private blur(): void {
    document.getElementById("app")!.className = 'blur';
  }

  private resetTimer(): void {
    document.getElementById("app")!.className = '';

    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
    }
    if (this.blurTimer) {
      clearTimeout(this.blurTimer);
    }
    if (this.warningTimer) {
      clearTimeout(this.warningTimer);
    }
    //@ts-expect-error
    this.blurTimer = setTimeout(() => this.blur(), 3 * 60 * 1000); // 3 minutes

    let millisecondsToLogout = 30 * 60 * 1000; //30 minutes
    if (this.token) {
      try {
        const decoded = jwtDecode(this.token);
        if (decoded.exp) {
          // Se il JWT scade prima del logout automatico, imposta il logout alla scadenza del token
          const millisecondsToTokenExpire = (decoded.exp * 1000) - Date.now();
          millisecondsToLogout = Math.min(millisecondsToLogout, millisecondsToTokenExpire);

          const warningTime = millisecondsToLogout - 2 * 60 * 1000; // Avviso a 2 minuti dalla scadenza
          if (warningTime > 0) {
            //@ts-expect-error
            this.warningTimer = setTimeout(() => this.logger.logWarning(this.ts.t(
              'Warning, in two minutes you will be automatically disconnected. Remember to save your data so you don\'t lose them'), { autoClose: 2 * 60 * 1000 }), warningTime);
          }
        }
      } catch (_e) { }
    }
    //@ts-expect-error
    this.logoutTimer = setTimeout(() => this.userService.setIsLogged(false), millisecondsToLogout);
  }

  public setupSessionExpiringTimer() {
    let w = new Worker("/userSession.js");
    const userService = getContainer(Contexts.SHARED).get(NamedBindings.UserService) as UserService;
    const currentCaseService = getContainer(Contexts.DEFAULT).get(NamedBindings.CurrentCaseService) as CurrentCaseService;
    w.onmessage = function (event) {
      if (event.data === 'logout') {
        w.terminate()
        currentCaseService.save();
        userService.setIsLogged(false);
      }
    }

    window.addEventListener("blur", (_event) => {
      w.postMessage('enableTimeoutForLogout')
    });
    window.addEventListener("focus", (_event) => {
      w.postMessage('disableTimeoutForLogout')
    });
    window.addEventListener("click", (_event) => {
      w.postMessage('disableTimeoutForLogout')
    });
  }
}

